import { AppBar, Toolbar } from "@mui/material";
import {
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
} from "@websential/cosmic-v20";

import { FC } from "react";

export interface IErrorTransacitonsToolbar {
	onDeleteButtonClickedHandler: () => void
}

export const ErrorTransacitonsToolbar: FC<IErrorTransacitonsToolbar> = ({
	onDeleteButtonClickedHandler,
}) => {
	return (
		<AppBar
			position="sticky"
			color="default"
			elevation={1}
			data-testId={""}
			sx={{
				backgroundColor: "#fff",
				boxShadow: "none",
				alignItems: "center",
				zIndex: 0,
			}}
		>
			<Toolbar>
				<EnhancedButtonPrimeReact
					// icon="pi pi-trash"
					label="Error Removed, Reprocess"
					raised
					onClickHandler={onDeleteButtonClickedHandler}
					style={{ marginRight: "1rem" }}
					severity={EnhancedButtonPrimeReactSeverity.Success}
				/>
			</Toolbar>
		</AppBar>
	);
};
